import { render, staticRenderFns } from "./LeasesTabs.vue?vue&type=template&id=1bd36783&"
import script from "./LeasesTabs.vue?vue&type=script&lang=js&"
export * from "./LeasesTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sbrown/projects/okinus/ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1bd36783')) {
      api.createRecord('1bd36783', component.options)
    } else {
      api.reload('1bd36783', component.options)
    }
    module.hot.accept("./LeasesTabs.vue?vue&type=template&id=1bd36783&", function () {
      api.rerender('1bd36783', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/features/leases/components/LeasesTabs.vue"
export default component.exports